var render, staticRenderFns
import script from "./PortalIcon.vue?vue&type=script&lang=js&"
export * from "./PortalIcon.vue?vue&type=script&lang=js&"
import style0 from "./PortalIcon.vue?vue&type=style&index=0&id=6b5d9a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d9a96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5d9a96')) {
      api.createRecord('6b5d9a96', component.options)
    } else {
      api.reload('6b5d9a96', component.options)
    }
    
  }
}
component.options.__file = "src/components/PortalIcon.vue"
export default component.exports